import type { FieldProps } from 'formik';
import { useCallback } from 'react';

import {
  YesNoMultiselect,
  type YesNoMultiselectProps,
} from 'src/components/base/controls/YesNoMultiselect/YesNoMultiselect';
import { withField } from 'src/helpers';
import { withFieldError } from 'src/helpers/withFieldError';

type YesNoMultiselectFieldProps = FieldProps<boolean[]> & { name: string } & Omit<YesNoMultiselectProps, 'onChange'>;

export const YesNoMultiselectField = withField(
  withFieldError(({ field, form: { setFieldValue, setFieldTouched }, ...rest }: YesNoMultiselectFieldProps) => {
    const onChange = useCallback(
      async (value: boolean[]) => {
        await setFieldValue(field.name, value, true);
        await setFieldTouched(field.name, true);
      },
      [field.name, setFieldValue, setFieldTouched]
    );

    return <YesNoMultiselect {...field} {...rest} onChange={onChange} />;
  })
);
